import {
    AMC_OTHER_DETAILS_SET_VALUE,
    AMC_OTHER_DETAILS_SET_VALID,
    AMC_FORM_INVALID_TRANSITION_OTHER_DETAILS,
    AMC_FORM_VALID_TRANSITION_OTHER_DETAILS,
} from '../../actions/allSureMotorClaim/otherDetails';
import { RADIO_OPTION } from '../../actions/allSureMotorClaim/types';
import { FIELD_STATUS, FORM_STATUS } from '../status';

const calculateDaysFromDate = (incidentDate) => {
    const [day, month, year] = incidentDate.split('/').map(Number);
    const incident = new Date(year, month - 1, day);
    const currentDate = new Date();
    const timeDiff = currentDate - incident;
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    return days;
};

export const initOtherDetails = {
    formStatus: FORM_STATUS.INVALID,
    form: {
        description: { value: null, error: null, status: null, displayValue: null },
        windScreenSize: { value: null, error: null, status: null, displayValue: null },
        brokenGlass: { value: null, error: null, status: null, displayValue: null },
        crackOrShattered: { value: null, error: null, status: null, displayValue: null },
        dateOfIncident: {
            value: null,
            error: null,
            status: null,
        },
        reasonForDelay: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: '',
            dependentField: 'dateOfIncident',
            validationCondition: (currentfield, dependentField) =>
                dependentField.value && calculateDaysFromDate(dependentField.value) >= 30 && calculateDaysFromDate(dependentField.value) <= 1096,
        },
        timeOfIncident: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
        },
        placeWhereTheftOccurred: { value: null, error: null, status: null, displayValue: null },
        policeStationReportedTo: { value: null, error: null, status: null, displayValue: null },
        sapsCaseNumber: { value: null, error: null, status: null, displayValue: null },
        dateReported: { value: null, error: null, status: null, displayValue: null },
        reportedBy: { value: null, error: null, status: null, displayValue: null },
        circumstancesOfTheft: { value: null, error: null, status: null, displayValue: null },
        vehicleLocked: { value: null, error: null, status: null, displayValue: null },
        reasonOfLock: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: RADIO_OPTION.NO,
            dependentField: 'vehicleLocked',
        },
        detailsStolenAccessories: { value: null, error: null, status: FIELD_STATUS.VALID, displayValue: null },
        associateSecured: { value: null, error: null, status: FIELD_STATUS.VALID, displayValue: null },
        antiTheft: { value: null, error: null, status: null, displayValue: null },
        make: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: RADIO_OPTION.YES,
            dependentField: 'antiTheft',
        },
        fittedBy: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: RADIO_OPTION.YES,
            dependentField: 'antiTheft',
        },
        dateFitted: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: RADIO_OPTION.YES,
            dependentField: 'antiTheft',
        },
        windowNumber: { value: null, error: null, status: FIELD_STATUS.VALID, displayValue: null },
        appliedByWhom: { value: null, error: null, status: FIELD_STATUS.VALID, displayValue: null },
        detailsOfDents: { value: null, error: null, status: null, displayValue: null },
        detailsOfOtherFeatures: { value: null, error: null, status: null, displayValue: null },
        nameOfPoliceOfficer: { value: null, error: null, status: null, displayValue: null },
        stationName: { value: null, error: null, status: null, displayValue: null },
        referenceNumber: { value: null, error: null, status: null, displayValue: null },
        dateOfReported: { value: null, error: null, status: null, displayValue: null },
        testedAlcohol: { value: null, error: null, status: null, displayValue: null },
        descriptionOfAccident: { value: null, error: null, status: null, displayValue: null },
        
        
        parked:{ value: null, error: null, status: null, displayValue: null },
        driverName: { value: null, error: null, status: null, displayValue: null,
            dependentValue: '',
            dependentField: 'parked',
            validationCondition: (currentfield, dependentField) => dependentField.value && dependentField?.value === 'Driven',
         },
        driverIdNumber: { value: null, error: null, status: null, displayValue: null,
            dependentValue: '',
            dependentField: 'parked',
            validationCondition: (currentfield, dependentField) => dependentField.value && dependentField?.value === 'Driven',
         },
        driverAge: { value: null, error: null, status: null, displayValue: null,
            dependentValue: '',
            dependentField: 'parked',
            validationCondition: (currentfield, dependentField) => dependentField.value && dependentField?.value === 'Driven',
         },
        driverLicense: { value: null, error: null, status: null, displayValue: null,
            dependentValue: '',
            dependentField: 'parked',
            validationCondition: (currentfield, dependentField) => dependentField.value && dependentField?.value === 'Driven',
         },
        driverLicenseNumber: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: '',
            dependentField: 'driverLicense',
            validationCondition: (currentfield, dependentField) => dependentField.value && dependentField?.value === 'Full',
        },
        driverLicenseCode: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: '',
            dependentField: 'driverLicense',
            validationCondition: (currentfield, dependentField) => dependentField.value && dependentField?.value === 'Full',
        },
        vehicleUse: { value: null, error: null, status: null, displayValue: null,
            dependentValue: '',
            dependentField: 'parked',
            validationCondition: (currentfield, dependentField) => dependentField.value && dependentField?.value === 'Driven',
         },
        driverOwner: { value: null, error: null, status: null, displayValue: null,
            dependentValue: '',
            dependentField: 'parked',
            validationCondition: (currentfield, dependentField) => dependentField.value && dependentField?.value === 'Driven',
        },
        drivingPermission: { value: null, error: null, status: null, displayValue: null,
            dependentValue: '',
            dependentField: 'driverOwner',
            validationCondition: (currentfield, dependentField) => dependentField.value && dependentField?.value === RADIO_OPTION.NO,
        },
        employee: { value: null, error: null, status: null, displayValue: null,
            dependentValue: '',
            dependentField: 'driverOwner',
            validationCondition: (currentfield, dependentField) => dependentField.value && dependentField?.value === RADIO_OPTION.NO,
         },
        ownerOfOtherVehicle: { value: null, error: null, status: FIELD_STATUS.VALID, displayValue: null,
            dependentValue: '',
            dependentField: 'driverOwner',
            validationCondition: (currentfield, dependentField) => dependentField.value && dependentField?.value === RADIO_OPTION.NO,
         },
        nameOfInsurer: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: '',
            dependentField: 'ownerOfOtherVehicle',
            validationCondition: (currentField, dependentField) =>
                dependentField.value && dependentField?.value === RADIO_OPTION.YES,
        },
        policyNumber: {
            value: null,
            error: null,
            status: null,
            displayValue: null,
            dependentValue: '',
            dependentField: 'ownerOfOtherVehicle',
            validationCondition: (currentField, dependentField) =>
                dependentField.value && dependentField?.value === RADIO_OPTION.YES,
        },
        convictionsDetails: { value: null, error: null, status: null, displayValue: null,
            dependentValue: '',
            dependentField: 'driverOwner',
            validationCondition: (currentfield, dependentField) => dependentField.value && dependentField?.value === RADIO_OPTION.NO,
         },
        licenseEndorse: { value: null, error: null, status: null, displayValue: null,
            dependentValue: '',
            dependentField: 'driverOwner',
            validationCondition: (currentfield, dependentField) => dependentField.value && dependentField?.value === RADIO_OPTION.NO,
         },
        physicalDefects: { value: null, error: null, status: null, displayValue: null,
            dependentValue: '',
            dependentField: 'driverOwner',
            validationCondition: (currentfield, dependentField) => dependentField.value && dependentField?.value === RADIO_OPTION.NO,
         },
        previousAccidentDetails: { value: null, error: null, status: null, displayValue: null,
            dependentValue: '',
            dependentField: 'driverOwner',
            validationCondition: (currentfield, dependentField) => dependentField.value && dependentField?.value === RADIO_OPTION.NO,
         },


        
        thirdParty: { value: null, error: null, status: null, displayValue: null },
        thirdPartyMake: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: '',
            dependentField: 'thirdParty',
            validationCondition: (currentField, dependentField) =>
                dependentField.value && dependentField?.value === RADIO_OPTION.YES,
        },
        thirdPartyRegistrationNumber: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: '',
            dependentField: 'thirdParty',
            validationCondition: (currentField, dependentField) =>
                dependentField.value && dependentField?.value === RADIO_OPTION.YES,
        },
        thirdPartyNameOfOwner: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: '',
            dependentField: 'thirdParty',
            validationCondition: (currentField, dependentField) =>
                dependentField.value && dependentField?.value === RADIO_OPTION.YES,
        },
        thirdPartyAddressOfOwner: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: '',
            dependentField: 'thirdParty',
            validationCondition: (currentField, dependentField) =>
                dependentField.value && dependentField?.value === RADIO_OPTION.YES,
        },
        thirdPartyDriverName: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: '',
            dependentField: 'thirdParty',
            validationCondition: (currentField, dependentField) =>
                dependentField.value && dependentField?.value === RADIO_OPTION.YES,
        },
        thirdPartyAddressOfDriver: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: '',
            dependentField: 'thirdParty',
            validationCondition: (currentField, dependentField) =>
                dependentField.value && dependentField?.value === RADIO_OPTION.YES,
        },
        thirdPartyEmailDriver: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: '',
            dependentField: 'thirdParty',
            validationCondition: (currentField, dependentField) =>
                dependentField.value && dependentField?.value === RADIO_OPTION.YES,
        },
        thirdPartyInsuranceCompanyName: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: '',
            dependentField: 'thirdParty',
            validationCondition: (currentField, dependentField) =>
                dependentField.value && dependentField?.value === RADIO_OPTION.YES,
        },
        thirdPartyPolicyNumber: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: '',
            dependentField: 'thirdParty',
            validationCondition: (currentField, dependentField) =>
                dependentField.value && dependentField?.value === RADIO_OPTION.YES,
        },
        anyOtherProperty: { value: null, error: null, status: null, displayValue: null },
        detailOfDamageProperty: { value: null, error: null, status: null, displayValue: null,
            dependentValue: '',
            dependentField: 'anyOtherProperty',
            validationCondition: (currentField, dependentField) =>
                dependentField.value && dependentField?.value === RADIO_OPTION.YES,
        },
        nameOfOwner: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: '',
            dependentField: 'detailOfDamageProperty',
            validationCondition: (currentField, dependentField) =>
                dependentField.value && dependentField?.value === RADIO_OPTION.YES,
        },
        addressOfOwner: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: '',
            dependentField: 'detailOfDamageProperty',
            validationCondition: (currentField, dependentField) =>
                dependentField.value && dependentField?.value === RADIO_OPTION.YES,
        },
        detailsDamage: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: '',
            dependentField: 'detailOfDamageProperty',
            validationCondition: (currentField, dependentField) =>
                dependentField.value && dependentField?.value === RADIO_OPTION.YES,
        },
        outSidePersonalInjuries: { value: null, error: null, status: null, displayValue: null },
        detailsOfInjuries: { value: null, error: null, status: FIELD_STATUS.VALID, displayValue: null,
            dependentField: 'outSidePersonalInjuries',
            validationCondition: (currentField, dependentField) =>
                dependentField.value && dependentField?.value === RADIO_OPTION.YES,
        },
        nameOfInjured: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: '',
            dependentField: 'detailsOfInjuries',
            validationCondition: (currentField, dependentField) =>
                dependentField.value && dependentField?.value === RADIO_OPTION.YES,
        },
        nameOfHospital: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: '',
            dependentField: 'detailsOfInjuries',
            validationCondition: (currentField, dependentField) =>
                dependentField.value && dependentField?.value === RADIO_OPTION.YES,
        },
        detailsOfInjury: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: '',
            dependentField: 'detailsOfInjuries',
            validationCondition: (currentField, dependentField) =>
                dependentField.value && dependentField?.value === RADIO_OPTION.YES,
        },
        relationShipToAccident: {
            value: null,
            error: null,
            status: FIELD_STATUS.VALID,
            displayValue: null,
            dependentValue: '',
            dependentField: 'detailsOfInjuries',
            validationCondition: (currentField, dependentField) =>
                dependentField.value && dependentField?.value === RADIO_OPTION.YES,
        },
        witness: { value: null, error: null, status: FIELD_STATUS.VALID, displayValue: null },
    },
};

const defaultFieldState = () => ({
    value: null,
    error: null,
    status: null,
    displayValue: null,
});
export default (state = initOtherDetails, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });
    switch (action.type) {
        case AMC_FORM_VALID_TRANSITION_OTHER_DETAILS:
            return { ...state, formStatus: FORM_STATUS.VALID };
        case AMC_FORM_INVALID_TRANSITION_OTHER_DETAILS:
            return { ...state, formStatus: FORM_STATUS.INVALID };
        case AMC_OTHER_DETAILS_SET_VALUE:
            return updateFormField(action.value.fieldType, (field) => ({
                ...field,
                displayValue: action.value.displayValue ?? action.value.value,
                value: action.value.value,
            }));

        case AMC_OTHER_DETAILS_SET_VALID:
            const { fieldType, error } = action;
            return updateFormField(fieldType, (field) => ({
                ...field,
                error: error,
                status: mapError(error),
            }));

        case 'UPDATE_WITNESS_COUNT_OTHER': {
            const witnessCount = action.payload;
            const updatedForm = { ...state.form };

            Object.keys(updatedForm).forEach((key) => {
                if (/^witness(Name|Phone|Address)_\d+$/.test(key)) {
                    delete updatedForm[key];
                }
            });
            if (!witnessCount || witnessCount === 'None') {
                return {
                    ...state,
                    form: {
                        ...updatedForm,
                    },
                };
            }

            for (let i = 1; i <= witnessCount; i++) {
                updatedForm[`witnessName_${i}`] = defaultFieldState();
                updatedForm[`witnessAddress_${i}`] = defaultFieldState();
                updatedForm[`witnessPhone_${i}`] = defaultFieldState();
            }

            return {
                ...state,
                form: {
                    ...updatedForm,
                    witness: {
                        value: witnessCount,
                        error: null,
                        status: null,
                        displayValue: witnessCount,
                    },
                },
            };
        }

        case 'UPDATE_WITNESS_DETAILS_OTHER': {
            const { field, value, displayValue } = action.payload;

            return {
                ...state,
                form: {
                    ...state.form,
                    [field]: {
                        ...(state.form[field] || { value: null, error: null, status: null, displayValue: null }),
                        value,
                        displayValue,
                    },
                },
            };
        }

        default:
            return state;
    }
};
